export default __webpack_public_path__ + "static/media/website-s-hover-icon.31c6046d.svg";